export const PROGRESS_STEPS = [
  'Analyzing prompt',
  'Thinking',
  'Building questions',
  'Finalizing output',
];

export const LONG_POLLING_THRESHOLD_MS = 35000;

export const PER_STEP_DURATIONS_MS = [4500, 4500, 3500, 1200];

export const MAX_QUESTIONS_PER_RUN = 10;
export const DEFAULT_BASE_LENGTH = 5;
